import React from 'react';
import { eTransactionType } from 'types/administration/pricing/eTransactionType';
import { BodyText, Card } from 'ui-toolkit/components';
import { screamingSnakeCaseToCapitalize } from 'utilities/shared/stringMethods/stringMethods';

interface ITransactionTypesViewerProps {
  transactionTypes: eTransactionType[];
}

export const TransactionTypesViewer: React.FC<ITransactionTypesViewerProps> = ({ transactionTypes }) => {
  return (
    <Card>
      {transactionTypes.map((transactionType) => (
        <BodyText key={transactionType}>{screamingSnakeCaseToCapitalize(transactionType)}</BodyText>
      ))}
    </Card>
  );
};
